module.exports = __webpack_public_path__ + "img/avtomir.3b231754.svg";